module.exports = __webpack_public_path__ + "img/welfare-coupon.bf5864c6.png";